import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#00A5C5' ,
                secondary: '#00C1BE',
                neutral: '#979797',
                accent: '#00C1BE',
                error: '#B4151C',
                danger: '#ca210f',
                success: '#44DAA5',
                warning: '#F9F871',
                flagger: '#57A0D3',
            },
        }
    },
    icons: {
        iconfont: 'md'
    },
});
